import { StoreState } from "../../types/storeTypes";

export function selectProperty<T>(state: StoreState, propertyName: string): T | undefined {
    const properties = state.properties.properties;
    return properties ? properties.get(propertyName) as T | undefined : undefined;
}
